import DashboardService from "@/src/api/DashboardService.js";

export const fetchMeetingDispositions = async ({
  search = "",
  page = 1,
  page_size = 40,
} = {}) => {
  try {
    const params = {
      page,
      page_size,
    };

    if (search) {
      params.search = search;
    }

    const response = await DashboardService.fetchMeetingDispositions(params);
    if (response) {
      return response;
    }
    return { data: [], total: 0 };
  } catch (error) {
    console.error("Error fetching meeting dispositions: ", error);
    return { data: [], total: 0 };
  }
};

export const createMeetingDisposition = async (dispositionName) => {
  try {
    const payload = { disposition: dispositionName };
    const response = await DashboardService.createMeetingDisposition(payload);
    if (response?.success) {
      return response.disposition;
    }
    throw new Error("Failed to create meeting disposition");
  } catch (error) {
    console.error("Error creating meeting disposition: ", error);
    throw error;
  }
};

export const updateMeetingDispositionSetting = async (dispositionId, dispositionName) => {
  try {
    const payload = { disposition: dispositionName };
    const response = await DashboardService.updateMeetingDispositionSetting(dispositionId, payload);
    if (response?.success) {
      return response.disposition;
    }
    throw new Error("Failed to update meeting disposition setting");
  } catch (error) {
    console.error("Error updating meeting disposition setting: ", error);
    throw error;
  }
};

export const deleteMeetingDisposition = async (dispositionId) => {
  try {
    const response = await DashboardService.deleteMeetingDisposition(dispositionId);
    if (response?.success) {
      return response.message;
    }
    throw new Error("Failed to delete meeting disposition");
  } catch (error) {
    console.error("Error deleting meeting disposition: ", error);
    throw error;
  }
};

export const saveMeetingDisposition = async (meetingId, disposition) => {
  try {
    const response = await DashboardService.updateMeetingDisposition(meetingId, disposition);
    if (response?.success) {
      return { success: true, data: response };
    }
    return { success: false, error: "Failed to update meeting disposition" };
  } catch (error) {
    console.error("Error saving meeting disposition: ", error);
    return { success: false, error: error.message || "Update failed" };
  }
};

